import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import { getUrlParameter } from '../../../utils'
import {
  logoutAndRedirect,
  userIsLoggedInDataFetched
} from '../../../actions/auth'
import { hideModal } from '../../../actions/_modal'
import {
  acceptPolicies,
  userIsConsideringDecliningPolicies,
  userIsNotConsideringDecliningPolicies
} from '../../../actions/policies'
import Modal from '../../mini/Modal'
import { H3PolicyModal, P2PolicyModal } from './_Styled'

export class AcceptPolicyModal extends Component {
  constructor(props) {
    super(props)
    this.onViewOurPoliciesClickBound = this.onViewOurPoliciesClick.bind(this)
    this.onAgreeClickBound = this.onAgreeClick.bind(this)
    this.onDeclineClickBound = this.onDeclineClick.bind(this)
    this.onYesIAmDecliningClickBound = this.onYesIAmDecliningClick.bind(this)
  }

  render() {
    const { userIsConsideringDecliningPolicies } = this.props
    return (
      <Modal
        top={50}
        width={520}
        autoHeight
        background={'#f5f5f5'}
        // opacity={getUrlParameter('il') ? '1.0' : '0.45'}
        borderRadius="8px"
        boxShadow="0 1px 9px 0 rgba(0,0,0,0.08)"
      >
        <div className="policy-acceptance-modal-container">
          {!userIsConsideringDecliningPolicies ? (
            <React.Fragment>
              <H3PolicyModal>
                Please agree to our policies to continue.
              </H3PolicyModal>
              <P2PolicyModal>
                By using the OE Quest! app, you agree to our policies, including
                the End User Agreement, Privacy Policy, and the Terms and
                Conditions.
              </P2PolicyModal>
              <div
                className="view-our-policies quest-text-btn"
                onClick={this.onViewOurPoliciesClickBound}
              >
                View Our Policies
              </div>
              <div className="actions">
                <div
                  className="quest-btn btn-c decline"
                  onClick={this.onDeclineClickBound}
                >
                  Decline
                </div>
                <div
                  className="quest-btn btn-a agree"
                  onClick={this.onAgreeClickBound}
                >
                  Agree
                </div>
              </div>
            </React.Fragment>
          ) : (
            <div className="are-you-sure">
              <H3PolicyModal>Are you sure you want to decline?</H3PolicyModal>
              <P2PolicyModal>
                To use the OE Quest! app, you must agree to these terms. Click
                'Agree to OE Policies' to accept the terms now.
              </P2PolicyModal>
              <div
                className="view-our-policies quest-text-btn"
                onClick={this.onViewOurPoliciesClickBound}
              >
                Go Back to Policies
              </div>
              <div className="actions">
                <div
                  className="quest-btn btn-d decline"
                  onClick={this.onYesIAmDecliningClickBound}
                >
                  Decline and Leave
                </div>
                <div
                  className="quest-btn btn-a active uncap"
                  onClick={this.onAgreeClickBound}
                >
                  Agree and Continue
                </div>
              </div>
            </div>
          )}
        </div>
      </Modal>
    )
  }

  onViewOurPoliciesClick() {
    this.props.dispatch(userIsLoggedInDataFetched())
    this.props.dispatch(hideModal())
    this.props.dispatch(userIsNotConsideringDecliningPolicies())
    this.props.dispatch(push('/policies'))
  }

  onAgreeClick() {
    this.props.dispatch(acceptPolicies())
  }

  onDeclineClick() {
    this.props.dispatch(userIsConsideringDecliningPolicies())
  }

  onYesIAmDecliningClick() {
    this.props.dispatch(logoutAndRedirect())
    this.props.dispatch(hideModal())
    this.props.dispatch(userIsNotConsideringDecliningPolicies())
  }
}

AcceptPolicyModal.propTypes = {
  dispatch: PropTypes.func,
  userIsConsideringDecliningPolicies: PropTypes.bool
}

export function mapStateToProps(state) {
  return {
    userIsConsideringDecliningPolicies:
      state.policies.userIsConsideringDecliningPolicies
  }
}

export default connect(mapStateToProps)(AcceptPolicyModal)
